module.exports = __webpack_public_path__ + "static/download/Baemin_Story_2025.pdf";